'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _emailValidator = require('email-validator');

var _emailValidator2 = _interopRequireDefault(_emailValidator);

var _zendesk = require('redux/modules/zendesk');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_ERROR = 'Field cannot be empty';
var EMAIL_ERROR = 'Invalid email address';

var ContactBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    zendesk: state.zendesk
  };
}, null, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(ContactBox, _React$Component);

  function ContactBox(props) {
    (0, _classCallCheck3.default)(this, ContactBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContactBox.__proto__ || (0, _getPrototypeOf2.default)(ContactBox)).call(this, props));

    _this.state = {
      name: '',
      email: props.auth && props.auth.user && props.auth.user.email,
      subject: '',
      comment: '',
      tag: props.tag,
      errors: {
        name: '',
        email: '',
        subject: '',
        comment: ''
      },
      active: {
        name: false,
        email: false,
        subject: false,
        comment: false
      },
      touched: {
        name: true,
        email: true,
        comment: true,
        subject: true
      }
    };
    return _this;
  }

  (0, _createClass3.default)(ContactBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var zendesk = this.props.zendesk;
      var posted = zendesk.posted,
          posting = zendesk.posting;


      if (posted == false && posting == false) this.refs.name.focus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch((0, _zendesk.resetZendesk)());
    }
  }, {
    key: 'onNameChange',
    value: function onNameChange(name) {
      var error = name.length <= 0;
      this.setState({ name: name, errors: (0, _extends3.default)({}, this.state.errors, { name: error ? INPUT_ERROR : '' }) });
    }
  }, {
    key: 'onEmailChange',
    value: function onEmailChange(email) {
      var error = !_emailValidator2.default.validate(email);
      this.setState({ email: email, errors: (0, _extends3.default)({}, this.state.errors, { email: error ? EMAIL_ERROR : '' }) });
    }
  }, {
    key: 'onSubjectChange',
    value: function onSubjectChange(subject) {
      var error = subject.length <= 0;
      this.setState({ subject: subject, errors: (0, _extends3.default)({}, this.state.errors, { subject: error ? INPUT_ERROR : '' }) });
    }
  }, {
    key: 'onCommentChange',
    value: function onCommentChange(e) {
      var comment = e.target.value;
      var error = comment.length <= 0;

      this.setState({ comment: comment, errors: (0, _extends3.default)({}, this.state.errors, { comment: error ? INPUT_ERROR : '' }) });
    }
  }, {
    key: 'onPostMessage',
    value: function onPostMessage() {
      var _state = this.state,
          name = _state.name,
          email = _state.email,
          subject = _state.subject,
          comment = _state.comment;
      var tag = this.props.tag;


      var nameError = false,
          subjectError = false,
          commentError = false,
          emailError = false;

      nameError = name.length <= 0;
      subjectError = subject.length <= 0;
      commentError = comment.length <= 0;
      emailError = !_emailValidator2.default.validate(email);

      if (nameError || emailError || subjectError || commentError) {
        this.setState({ errors: { name: nameError ? INPUT_ERROR : '', email: emailError ? EMAIL_ERROR : '', subject: subjectError ? INPUT_ERROR : '', comment: commentError ? INPUT_ERROR : '' } });
        return;
      }

      this.props.dispatch((0, _zendesk.createTicket)({ email: email, name: name, subject: subject, comment: comment, tag: tag }));
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.props.onCloseNo('Cancelled');
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'setActive',
    value: function setActive(field) {
      var active = this.state.active;
      active[field] = true;

      this.setState({ active: active });
    }
  }, {
    key: 'unsetActive',
    value: function unsetActive(field) {
      var active = this.state.active;
      active[field] = false;

      this.setState({ active: active });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _state$errors = this.state.errors,
          emailError = _state$errors.email,
          nameError = _state$errors.name,
          subjectError = _state$errors.subject,
          commentError = _state$errors.comment;
      var _state$touched = this.state.touched,
          emailTouched = _state$touched.email,
          nameTouched = _state$touched.name,
          subjectTouched = _state$touched.subject,
          commentTouched = _state$touched.comment;
      var _state$active = this.state.active,
          emailActive = _state$active.email,
          nameActive = _state$active.name,
          subjectActive = _state$active.subject,
          commentActive = _state$active.comment;
      var _props = this.props,
          auth = _props.auth,
          zendesk = _props.zendesk;
      var posting = zendesk.posting,
          posted = zendesk.posted,
          postError = zendesk.postError;


      var email = auth && auth.user && auth.user.email;
      var styles = require('./ContactBox.scss');

      var commentClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles['ContactUs__message'], true), (0, _defineProperty3.default)(_classnames, styles['Input__error'], commentError), (0, _defineProperty3.default)(_classnames, styles['Input__active'], commentActive), _classnames));

      var defaultSubject = this.props.subject || '';

      return _react2.default.createElement(
        _components.PopupBox,
        null,
        posting ? _react2.default.createElement(_components.LoadingIndicator, { className: styles['ContactBox__loading-indicator'] }) : posted ? _react2.default.createElement(
          'div',
          { className: styles['ContactBox__success-message'] },
          'Thank you! We have your feedback. We\'ll take a look shortly!'
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles['ContactBox__fields'] },
            _react2.default.createElement(
              'h2',
              { className: styles.ContactBox__title },
              this.props.title
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles['ContactBox__fields'] },
            _react2.default.createElement(
              'h2',
              { className: styles.ContactBox__message },
              this.props.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles['ContactForm__fields'] },
            _react2.default.createElement(_components.TextInput, { simpleError: true, active: nameActive, touched: nameTouched, error: nameError, ref: 'name', title: 'Name', className: styles['ContactForm__input--name'], onChange: this.onNameChange.bind(this),
              onBlur: function onBlur() {
                return _this2.unsetActive('name');
              },
              onFocus: function onFocus() {
                return _this2.setActive('name');
              } }),
            _react2.default.createElement(_components.TextInput, { simpleError: true, active: emailActive, touched: emailTouched, error: emailError, title: 'Email', defaultValue: email, className: styles['ContactForm__input--email'], onChange: this.onEmailChange.bind(this),
              onBlur: function onBlur() {
                return _this2.unsetActive('email');
              },
              onFocus: function onFocus() {
                return _this2.setActive('email');
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: styles['ContactForm__fields'] },
            _react2.default.createElement(_components.TextInput, { simpleError: true, active: subjectActive, touched: subjectTouched, error: subjectError, title: 'Subject', defaultValue: defaultSubject, className: styles['ContactForm__input--message'], onChange: this.onSubjectChange.bind(this),
              onBlur: function onBlur() {
                return _this2.unsetActive('subject');
              },
              onFocus: function onFocus() {
                return _this2.setActive('subject');
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: styles['ContactUs__message-label'] },
            'Your Message'
          ),
          _react2.default.createElement('textarea', { ref: 'textarea', rows: '4', className: commentClasses, onChange: this.onCommentChange.bind(this), onBlur: function onBlur() {
              return _this2.setState({ active: (0, _extends3.default)({}, _this2.state.active, { comment: false }) });
            }, onFocus: function onFocus() {
              return _this2.setState({ active: (0, _extends3.default)({}, _this2.state.active, { comment: true }) });
            } }),
          _react2.default.createElement(
            'div',
            { className: styles['ContactForm__buttons'] },
            _react2.default.createElement(_components.Button, { className: styles['ContactForm__button'], label: 'Cancel', onClick: this.handleCancelClick.bind(this) }),
            _react2.default.createElement(_components.Button, { primary: true, alternative: true, className: styles['ContactForm__button'], label: 'Send Message', onClick: this.onPostMessage.bind(this) })
          )
        )
      );
    }
  }]);
  return ContactBox;
}(_react2.default.Component)) || _class);
exports.default = ContactBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactBox/ContactBox.jsx
// module id = 2704
// module chunks = 0